import {skipToken} from '@reduxjs/toolkit/query';

import {useSelector} from 'react-redux';

import {isNotNil} from 'ramda';

import {selectCurrentUserInfo, useGetUserAvatarUrlQuery} from '@dms/api/customer';

/**
 * `getUserAvatarUrl` has no `serializeQueryArgs`, so the requested dimensions are part of the
 * RTK Query cache key. Every consumer of the signed-in user's avatar must therefore request the
 * exact same size, otherwise each one allocates its own cache entry and triggers its own request.
 */
const CURRENT_USER_AVATAR_SIZE = 120;

/**
 * Resolves the signed-in user's avatar through a single shared cache entry.
 *
 * Prefer this over calling `useGetUserAvatarUrlQuery` directly: the top bar mounts it on app start,
 * so any later consumer reads the already resolved value instead of waiting for a new request.
 */
export function useCurrentUserAvatarUrl() {
  const {data: userInfo} = useSelector(selectCurrentUserInfo);

  const {data: avatarUrl} = useGetUserAvatarUrlQuery(
    isNotNil(userInfo)
      ? {
          userId: userInfo.id,
          height: CURRENT_USER_AVATAR_SIZE,
          width: CURRENT_USER_AVATAR_SIZE,
        }
      : skipToken
  );

  return avatarUrl;
}
